export const FALLBACK_LANG = 'en'
